<template>

    <m-edit1/>

    <m-verify-email-request-1 v-bind='{...{"image":null},...{}}' :style='""' class="" ></m-verify-email-request-1>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mVerifyEmailRequest1 from '@moeinmdn/miw-alpha-components/src/package/Authentication/VerifyEmailRequest/VerifyEmailRequest1';

export default {
    name: 'HomeView',
    components: {mEdit1, mVerifyEmailRequest1 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
